module.exports = "/assets/image-mobile.jpg?jDcwU0v";